export default __webpack_public_path__ + "static/media/documento.96825b0f.svg";